import React, { useMemo, useState } from "react";
import { Container, Form, Button, Modal } from "react-bootstrap";
import { Chart } from "react-google-charts";

const CompanyHierarchy = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const hierarchyData = [
    {
      id: "001",
      name: "Vacant",
      email: "",
      bloodGroup: "",
      phone: "",
      title: "CEO",
      parent: "",
      joiningDate: "",
      details: "Company Leader",
    },
    {
      id: "002",
      name: "Pradeep Ponia",
      email: "pradeep@example.com",
      bloodGroup: "O+",
      phone: "9876543210",
      title: "MD - Sales & Marketing",
      parent: "001",
      joiningDate: "2022-01-10",
      details: "Leads sales and marketing",
    },
    {
      id: "003",
      name: "Anisha Chaudhary",
      email: "anisha@example.com",
      bloodGroup: "B+",
      phone: "8765432109",
      title: "MD - Finance",
      parent: "001",
      joiningDate: "2021-03-15",
      details: "Handles finances",
    },
    {
      id: "004",
      name: "Hariom Singh",
      email: "hariom@example.com",
      bloodGroup: "A+",
      phone: "7654321098",
      title: "MD - IT",
      parent: "001",
      joiningDate: "2023-06-20",
      details: "Manages IT and Tech",
    },
    {
      id: "005",
      name: "Rohit Mehra",
      email: "rohit@example.com",
      bloodGroup: "B+",
      phone: "9876500001",
      title: "Sales Manager",
      parent: "002",
      joiningDate: "2022-04-11",
      details: "Regional sales head",
    },
    {
      id: "006",
      name: "Simran Kaur",
      email: "simran@example.com",
      bloodGroup: "A-",
      phone: "9876500002",
      title: "Marketing Manager",
      parent: "002",
      joiningDate: "2022-07-19",
      details: "Brand campaigns and growth",
    },
    {
      id: "007",
      name: "Amit Verma",
      email: "amit@example.com",
      bloodGroup: "O+",
      phone: "9876500003",
      title: "Accounts Manager",
      parent: "003",
      joiningDate: "2021-09-12",
      details: "Oversees accounting operations",
    },
    {
      id: "008",
      name: "Neha Sharma",
      email: "neha@example.com",
      bloodGroup: "AB+",
      phone: "9876500004",
      title: "Audit Lead",
      parent: "003",
      joiningDate: "2021-11-09",
      details: "Financial compliance and audit",
    },
    {
      id: "009",
      name: "Karan Malhotra",
      email: "karan@example.com",
      bloodGroup: "O-",
      phone: "9876500005",
      title: "Tech Lead",
      parent: "004",
      joiningDate: "2023-01-08",
      details: "Leads core engineering team",
    },
    {
      id: "010",
      name: "Pooja Nair",
      email: "pooja@example.com",
      bloodGroup: "A+",
      phone: "9876500006",
      title: "UI/UX Lead",
      parent: "004",
      joiningDate: "2023-02-14",
      details: "Design systems and usability",
    },
    {
      id: "011",
      name: "Deepak Yadav",
      email: "deepak@example.com",
      bloodGroup: "B-",
      phone: "9876500007",
      title: "Sales Executive",
      parent: "005",
      joiningDate: "2023-03-20",
      details: "B2B client acquisition",
    },
    {
      id: "012",
      name: "Nisha Arora",
      email: "nisha@example.com",
      bloodGroup: "O+",
      phone: "9876500008",
      title: "Sales Executive",
      parent: "005",
      joiningDate: "2023-04-18",
      details: "Institutional sales",
    },
    {
      id: "013",
      name: "Gaurav Singh",
      email: "gaurav@example.com",
      bloodGroup: "A+",
      phone: "9876500009",
      title: "Digital Marketing Executive",
      parent: "006",
      joiningDate: "2023-05-16",
      details: "Performance marketing specialist",
    },
    {
      id: "014",
      name: "Ritika Jain",
      email: "ritika@example.com",
      bloodGroup: "B+",
      phone: "9876500010",
      title: "Content Strategist",
      parent: "006",
      joiningDate: "2023-06-11",
      details: "Campaign messaging and content",
    },
    {
      id: "015",
      name: "Vikas Rana",
      email: "vikas@example.com",
      bloodGroup: "AB-",
      phone: "9876500011",
      title: "Accountant",
      parent: "007",
      joiningDate: "2022-08-05",
      details: "Bookkeeping and reporting",
    },
    {
      id: "016",
      name: "Meenakshi Das",
      email: "meenakshi@example.com",
      bloodGroup: "O+",
      phone: "9876500012",
      title: "Accountant",
      parent: "007",
      joiningDate: "2022-10-22",
      details: "Invoice and ledger management",
    },
    {
      id: "017",
      name: "Sandeep Rawat",
      email: "sandeep@example.com",
      bloodGroup: "A-",
      phone: "9876500013",
      title: "Compliance Officer",
      parent: "008",
      joiningDate: "2022-12-01",
      details: "Regulatory documentation",
    },
    {
      id: "018",
      name: "Aarti Kapoor",
      email: "aarti@example.com",
      bloodGroup: "B+",
      phone: "9876500014",
      title: "QA Engineer",
      parent: "009",
      joiningDate: "2023-07-17",
      details: "Automation and testing",
    },
    {
      id: "019",
      name: "Mohit Bansal",
      email: "mohit@example.com",
      bloodGroup: "O+",
      phone: "9876500015",
      title: "Backend Developer",
      parent: "009",
      joiningDate: "2023-08-13",
      details: "APIs and database systems",
    },
    {
      id: "020",
      name: "Tanvi Sethi",
      email: "tanvi@example.com",
      bloodGroup: "A+",
      phone: "9876500016",
      title: "Frontend Developer",
      parent: "010",
      joiningDate: "2023-09-04",
      details: "React interfaces and UX flows",
    },
    {
      id: "021",
      name: "Yash Tandon",
      email: "yash@example.com",
      bloodGroup: "B+",
      phone: "9876500017",
      title: "UI Designer",
      parent: "010",
      joiningDate: "2023-09-28",
      details: "Visual design and prototyping",
    },
    {
      id: "022",
      name: "Priya Khanna",
      email: "priya@example.com",
      bloodGroup: "O-",
      phone: "9876500018",
      title: "HR Executive",
      parent: "001",
      joiningDate: "2023-10-11",
      details: "People and operations support",
    },
    {
      id: "023",
      name: "Rahul Dev",
      email: "rahul@example.com",
      bloodGroup: "A+",
      phone: "9876500019",
      title: "Support Engineer",
      parent: "009",
      joiningDate: "2024-01-06",
      details: "Technical support and deployment",
    },
    {
      id: "024",
      name: "Isha Bhatia",
      email: "isha@example.com",
      bloodGroup: "AB+",
      phone: "9876500020",
      title: "Business Analyst",
      parent: "004",
      joiningDate: "2024-02-09",
      details: "Requirement analysis and reporting",
    },
  ];

  const roleCounts = hierarchyData.reduce((acc, emp) => {
    const roles = (emp.title || "").split(",").map((r) => r.trim());
    roles.forEach((role) => {
      if (role) acc[role] = (acc[role] || 0) + 1;
    });
    return acc;
  }, {});

  const totalEmployees = hierarchyData.length;

  const createNodeCard = (person) => {
    return `
      <div class="elegant-node">
        <div class="elegant-node__inner">
          <div class="elegant-node__avatar">
            <img
              src="https://ui-avatars.com/api/?name=${encodeURIComponent(
                person.name
              )}&background=E8EEF9&color=2F5B8C&size=120"
              alt="${person.name}"
            />
          </div>

          <div class="elegant-node__content">
            <div class="elegant-node__name">${person.name}</div>
            <div class="elegant-node__title">${person.title}</div>
            <div class="elegant-node__meta">
              <span class="pill">ID ${person.id}</span>
              ${
                person.joiningDate
                  ? `<span class="pill pill--soft">${person.joiningDate}</span>`
                  : `<span class="pill pill--soft">Top Level</span>`
              }
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const chartData = useMemo(
    () => [
      ["Name", "Manager", "Tooltip"],
      ...hierarchyData.map((person) => [
        { v: person.id, f: createNodeCard(person) },
        person.parent,
        `${person.name} - ${person.title}`,
      ]),
    ],
    []
  );

  const handleChartSelection = ({ chartWrapper }) => {
    const selection = chartWrapper.getChart().getSelection();
    if (selection.length > 0) {
      const selectedId = chartData[selection[0].row + 1][0].v;
      const employee = hierarchyData.find((emp) => emp.id === selectedId);
      setSelectedEmployee(employee);
    }
  };

  const chartOptions = {
    allowHtml: true,
    allowCollapse: false,
    nodeClass: "org-wrapper",
    selectedNodeClass: "org-wrapper-selected",
  };

  if (!isAuthenticated) {
    return (
      <Container className="hierarchy-auth-wrap">
        <style>{styles}</style>
        <div className="auth-card">
          <div className="auth-card__badge">Secure Access</div>
          <h3 className="auth-card__title">Company Hierarchy</h3>
          <p className="auth-card__text">
            Enter password to view the organization structure
          </p>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              if (password === "NGOWaters") {
                setIsAuthenticated(true);
              } else {
                alert("Incorrect Password!");
              }
            }}
          >
            <Form.Control
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="premium-input mb-3"
            />
            <Button type="submit" className="premium-btn w-100">
              Continue
            </Button>
          </Form>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="hierarchy-page py-4 px-3 px-md-4">
      <style>{styles}</style>

      <div className="top-shell mb-4">
        <div className="page-head">
          <div>
            <div className="eyebrow">Organization Overview</div>
            <h1 className="page-title">Company Hierarchy</h1>
            <p className="page-subtitle">
              Elegant hierarchy view with interactive employee details
            </p>
          </div>
        </div>

        <div className="stats-row">
          <div className="mini-stat">
            <span>Total Employees</span>
            <strong>{totalEmployees}</strong>
          </div>

          {Object.entries(roleCounts).map(([role, count]) => (
            <div key={role} className="mini-stat">
              <span>{role}</span>
              <strong>{count}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="chart-panel">
        <Chart
          chartType="OrgChart"
          width="100%"
          height="700px"
          data={chartData}
          options={chartOptions}
          chartEvents={[
            {
              eventName: "select",
              callback: handleChartSelection,
            },
          ]}
        />
      </div>

      <Modal
        show={!!selectedEmployee}
        onHide={() => setSelectedEmployee(null)}
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title>Employee Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmployee && (
            <div className="employee-modal text-center">
              <img
                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                  selectedEmployee.name
                )}&background=E8EEF9&color=2F5B8C&size=140`}
                alt={selectedEmployee.name}
                className="modal-avatar"
              />

              <h4 className="modal-name">{selectedEmployee.name}</h4>
              <p className="modal-role">{selectedEmployee.title}</p>

              <div className="detail-box">
                <div>
                  <strong>Employee ID:</strong> {selectedEmployee.id}
                </div>
                <div>
                  <strong>Email:</strong> {selectedEmployee.email || "-"}
                </div>
                <div>
                  <strong>Phone:</strong> {selectedEmployee.phone || "-"}
                </div>
                <div>
                  <strong>Blood Group:</strong>{" "}
                  {selectedEmployee.bloodGroup || "-"}
                </div>
                <div>
                  <strong>Joining Date:</strong>{" "}
                  {selectedEmployee.joiningDate || "-"}
                </div>
                <div>
                  <strong>Manager:</strong>{" "}
                  {hierarchyData.find(
                    (emp) => emp.id === selectedEmployee.parent
                  )?.name || "None"}
                </div>
                <div>
                  <strong>Details:</strong> {selectedEmployee.details}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

const styles = `
:root {
  --bg: #eef3f9;
  --bg2: #e8eef6;
  --panel: rgba(255,255,255,0.50);
  --panel-strong: rgba(255,255,255,0.68);
  --border: rgba(255,255,255,0.60);
  --text: #1f2a37;
  --muted: #607086;
  --accent: #5b8def;
  --accent-soft: #edf4ff;
  --shadow-soft: 0 10px 30px rgba(31, 42, 55, 0.08);
  --shadow-mid: 0 18px 45px rgba(31, 42, 55, 0.10);
  --shadow-clay: 8px 8px 18px rgba(163, 177, 198, 0.18), -8px -8px 18px rgba(255,255,255,0.55);
}

body {
  background: linear-gradient(135deg, #edf2f8 0%, #f7f9fc 45%, #e8eef6 100%);
}

.hierarchy-page,
.hierarchy-auth-wrap {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(126, 156, 255, 0.10), transparent 22%),
    radial-gradient(circle at right center, rgba(168, 196, 255, 0.12), transparent 24%),
    linear-gradient(135deg, #edf2f8 0%, #f7f9fc 45%, #e8eef6 100%);
}

.hierarchy-auth-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-card,
.top-shell,
.chart-panel,
.detail-box,
.modal-content {
  background: var(--panel);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-soft);
}

.auth-card {
  width: 100%;
  max-width: 420px;
  padding: 32px;
  border-radius: 28px;
}

.auth-card__badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(91, 141, 239, 0.10);
  color: #446baf;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
}

.auth-card__title {
  color: var(--text);
  font-weight: 700;
  margin-bottom: 8px;
}

.auth-card__text {
  color: var(--muted);
  margin-bottom: 20px;
}

.premium-input {
  height: 48px;
  border-radius: 16px !important;
  border: 1px solid rgba(203, 213, 225, 0.8) !important;
  background: rgba(255,255,255,0.72) !important;
  color: var(--text) !important;
  box-shadow: inset 0 1px 2px rgba(255,255,255,0.4);
}

.premium-btn {
  height: 48px;
  border: none !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  background: linear-gradient(180deg, #6fa1ff 0%, #5b8def 100%) !important;
  box-shadow: 0 10px 20px rgba(91, 141, 239, 0.22);
}

.top-shell {
  padding: 24px;
  border-radius: 28px;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6d7f96;
  margin-bottom: 8px;
}

.page-title {
  font-size: 2rem;
  line-height: 1.15;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 8px;
}

.page-subtitle {
  margin: 0;
  color: var(--muted);
}

.stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.mini-stat {
  min-width: 160px;
  padding: 14px 18px;
  border-radius: 20px;
  background: var(--panel-strong);
  border: 1px solid rgba(255,255,255,0.65);
  box-shadow: var(--shadow-clay);
}

.mini-stat span {
  display: block;
  font-size: 12px;
  color: var(--muted);
  margin-bottom: 4px;
}

.mini-stat strong {
  font-size: 18px;
  color: var(--text);
  font-weight: 700;
}

.chart-panel {
  border-radius: 30px;
  padding: 18px;
  overflow: auto;
}

.google-visualization-orgchart-table {
  border-collapse: separate !important;
}

.google-visualization-orgchart-lineleft,
.google-visualization-orgchart-lineright,
.google-visualization-orgchart-linenode {
  border-color: rgba(122, 143, 170, 0.45) !important;
  border-width: 2px !important;
}

.org-wrapper,
.org-wrapper-selected {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 18px !important;
}

.elegant-node {
  width: 265px;
  border-radius: 28px;
  padding: 0;
  background: transparent;
}

.elegant-node__inner {
  position: relative;
  padding: 18px;
  border-radius: 28px;
  background:
    linear-gradient(180deg, rgba(255,255,255,0.72), rgba(255,255,255,0.46));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.70);
  box-shadow:
    0 14px 30px rgba(31, 42, 55, 0.09),
    inset 0 1px 0 rgba(255,255,255,0.75),
    6px 6px 16px rgba(163,177,198,0.12),
    -6px -6px 16px rgba(255,255,255,0.45);
  transition: transform 0.28s ease, box-shadow 0.28s ease;
}

.elegant-node__inner:hover {
  transform: translateY(-4px);
  box-shadow:
    0 20px 40px rgba(31, 42, 55, 0.12),
    inset 0 1px 0 rgba(255,255,255,0.82),
    8px 8px 20px rgba(163,177,198,0.14),
    -8px -8px 20px rgba(255,255,255,0.52);
}

.elegant-node__avatar {
  width: 62px;
  height: 62px;
  margin: 0 auto 14px;
  border-radius: 18px;
  padding: 5px;
  background: linear-gradient(180deg, rgba(255,255,255,0.80), rgba(240,245,252,0.75));
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), var(--shadow-soft);
}

.elegant-node__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
}

.elegant-node__content {
  text-align: center;
}

.elegant-node__name {
  font-size: 16px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 6px;
}

.elegant-node__title {
  font-size: 13px;
  line-height: 1.45;
  color: var(--muted);
  min-height: 38px;
  margin-bottom: 12px;
}

.elegant-node__meta {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pill {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(91, 141, 239, 0.11);
  color: #4c6fa6;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid rgba(91, 141, 239, 0.12);
}

.pill--soft {
  background: rgba(255,255,255,0.65);
  color: #6d7f96;
  border: 1px solid rgba(255,255,255,0.8);
}

.modal-content {
  border-radius: 28px !important;
  background: rgba(255,255,255,0.78) !important;
}

.employee-modal {
  padding: 8px 4px 12px;
}

.modal-avatar {
  width: 92px;
  height: 92px;
  border-radius: 24px;
  object-fit: cover;
  margin: 0 auto 14px;
  box-shadow: var(--shadow-soft);
}

.modal-name {
  color: var(--text);
  font-weight: 700;
  margin-bottom: 4px;
}

.modal-role {
  color: var(--muted);
  margin-bottom: 16px;
}

.detail-box {
  border-radius: 22px;
  padding: 18px;
  text-align: left;
  color: var(--text);
}

.detail-box > div {
  padding: 10px 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
}

.detail-box > div:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 1.6rem;
  }

  .elegant-node {
    width: 220px;
  }

  .elegant-node__inner {
    padding: 14px;
  }

  .chart-panel {
    padding: 10px;
  }

  .mini-stat {
    min-width: 140px;
  }
}
`;

export default CompanyHierarchy;
